(function () {
  function fix() {
    var g = document.querySelector('media-gallery');
    if (!g) return;
    var ss = g.querySelector('slideshow-component');
    if (!ss) return;
    var n = parseInt(ss.getAttribute('initial-slide') || '0', 10);
    if (!n) return;
    customElements.whenDefined('slideshow-component').then(function () {
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          try {
            var slides = ss.querySelectorAll('slideshow-slide');
            var target = slides[n];
            if (!target) return;
            var r = target.getBoundingClientRect();
            var R = ss.getBoundingClientRect();
            var visible = r.width > 0 && r.left >= R.left - 4 && r.right <= R.right + 4;
            if (visible) return; /* 已在位,别闪 */
            ss.current = 0;                      /* 绕开 select 的同张早退 */
            ss.select(n, undefined, { animate: false });
          } catch (e) {}
        });
      });
    });
  }
  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var m = muts[i];
      for (var j = 0; j < m.addedNodes.length; j++) {
        var nd = m.addedNodes[j];
        if (nd.nodeType === 1 && ((nd.matches && nd.matches('media-gallery')) || (nd.querySelector && nd.querySelector('media-gallery')))) {
          fix();
          return;
        }
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState !== 'loading') fix();
  else document.addEventListener('DOMContentLoaded', fix);
})();
